import FlagDE2 from '../Resources/Flags/de.svg'
import FlagEN2 from '../Resources/Flags/en.svg'
import FlagNL from '../Resources/Flags/nl.svg'
import FlagFr from '../Resources/Flags/fr.svg'
import FlagIT from '../Resources/Flags/it.svg'
import FlagPL from '../Resources/Flags/pl.svg'
import FlagPT from '../Resources/Flags/pt.svg'
import FlagES from '../Resources/Flags/es.svg'
import FlagSE from '../Resources/Flags/se.svg'
import FlagGR from '../Resources/Flags/gr.svg'
import FlagCH from '../Resources/Flags/ch.svg'

const baseLanguages = [
  { icon: FlagDE2, translationKey: 'german', shortName: 'de' },
  { icon: FlagEN2, translationKey: 'english', shortName: 'en' },
  { icon: FlagNL, translationKey: 'dutch', shortName: 'nl' },
]

export const flowLanguages = [
  ...baseLanguages,
  { icon: FlagFr, translationKey: 'french', shortName: 'fr' },
  { icon: FlagIT, translationKey: 'italian', shortName: 'it' },
  { icon: FlagPL, translationKey: 'polish', shortName: 'pl' },
  { icon: FlagPT, translationKey: 'portuguese', shortName: 'pt' },
  { icon: FlagES, translationKey: 'spanish', shortName: 'es' },
  { icon: FlagSE, translationKey: 'swedish', shortName: 'sv' },
  { icon: FlagGR, translationKey: 'greek', shortName: 'el' },
  { icon: FlagCH, translationKey: 'swiss-french', shortName: 'gsw-FR' },
  { icon: FlagCH, translationKey: 'swiss-german', shortName: 'gsw-CH' },
]

export const languages = process.env.REACT_APP_THEME === 'flow' ? flowLanguages : baseLanguages

export const languageShortNames = languages.map(elem => elem.shortName)
